import styled from "styled-components";
import { unstyledButton } from "~/styles/CommonStyles";

const UnstyledButton = styled.button`
  ${unstyledButton};
`;

export default UnstyledButton;
